export default "__VITE_ASSET__hMDWMh6h__"